module.exports = {"220122001":"兴农街道","220122002":"宝塔街道","220122003":"和谐街道","220122004":"黄龙街道","220122100":"农安镇","220122101":"伏龙泉镇","220122102":"哈拉海镇","220122103":"靠山镇","220122104":"开安镇","220122105":"烧锅镇","220122106":"高家店镇","220122107":"华家镇","220122108":"三盛玉镇","220122109":"巴吉垒镇","220122110":"三岗镇","220122200":"前岗乡","220122201":"龙王乡","220122203":"万顺乡","220122204":"杨树林乡","220122205":"永安乡","220122206":"青山口乡","220122207":"黄鱼圈乡","220122208":"新农乡","220122209":"万金塔乡","220122210":"小城子乡","220122400":"洼中高农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220122.json
// module id = 698
// module chunks = 0